export default __webpack_public_path__ + "static/media/green_pressed.9e1d52d1.png";